import { createClient } from './clients/config'
import { BASE_API_GATEWAY_URL, BASE_API_URL } from './endpoints.constants'

const parseParams = (params) => {
    const keys = Object.keys(params)
    let options = ''

    keys.forEach((key) => {
        const isParamTypeObject = typeof params[key] === 'object'
        const isParamTypeArray = isParamTypeObject && params[key].length >= 0

        if (!isParamTypeObject) {
            options += `${key}=${params[key]}&`
        }

        if (isParamTypeObject && isParamTypeArray) {
            params[key].forEach((element) => {
                options += `${key}=${element}&`
            })
        }
    })

    return options ? options.slice(0, -1) : options
}

export const axiosClient = ({ isBaseUrl = true }) => {
    return createClient(`${isBaseUrl ? BASE_API_URL : BASE_API_GATEWAY_URL}/api/v1`, isBaseUrl)
}

export function getRequest<T>(URL, params = {}, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .get<T>(`/${URL}`, { params })
        .then((response) => response)
}

export function getRequestWithParseParams(URL, params = {}, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .get(`/${URL}`, {
            params: { ...params },
            paramsSerializer: (params) => parseParams(params),
        })
        .then((response) => response)
}

export function postRequest<P, D>(URL: string, payload: P, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .post<D>(`/${URL}`, payload)
        .then((response) => response)
}

export function putRequest(URL, payload, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .put(`/${URL}`, payload)
        .then((response) => response)
}
export function patchRequest<T>(URL, payload: T, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .patch<T>(`/${URL}`, payload)
        .then((response) => response)
}

export function deleteRequest(URL, isBaseUrl = true) {
    return axiosClient({ isBaseUrl })
        .delete(`/${URL}`)
        .then((response) => response)
}
